import { RouterProvider } from '@tanstack/react-router';
import { router } from './providers/router';
import 'ui_2/src/index.css';

function App() {
  return (
    <div
      className='pb-safe fixed h-[100dvh] w-full'
      style={{
        viewTransitionName: 'full-page',
        contain: 'paint',
      }}
    >
      <div className='mx-auto h-full bg-white'>
        <RouterProvider router={router} />
      </div>
    </div>
  );
}

export default App;
